/**
 * The admin-facing words for a Location id the server refused (ticket 50). A place
 * of the network has one id, unique — the server refuses a taken one with
 * `CONFLICT` and an empty one with `BAD_REQUEST`; the screen names which.
 */
export function locationIdFailureKey(
	error: unknown,
): 'locations.idTaken' | 'locations.idEmpty' | 'locations.saveFailed' {
	const code = (error as { data?: { code?: string } } | null)?.data?.code
	if (code === 'CONFLICT') return 'locations.idTaken'
	if (code === 'BAD_REQUEST') return 'locations.idEmpty'
	return 'locations.saveFailed'
}
